__turbopack_context__.v({
  "bar": "styles-module-scss-module__PThV4q__bar",
  "diamond": "styles-module-scss-module__PThV4q__diamond",
  "isDarkMode": "styles-module-scss-module__PThV4q__isDarkMode",
  "thumb": "styles-module-scss-module__PThV4q__thumb",
  "track": "styles-module-scss-module__PThV4q__track",
});
